import { render, staticRenderFns } from "./SlidingTab.vue?vue&type=template&id=69b3daea&"
import script from "./SlidingTab.vue?vue&type=script&lang=js&"
export * from "./SlidingTab.vue?vue&type=script&lang=js&"
import style0 from "./SlidingTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports